//Constantes para almacenar el token en el localStorage
export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";
export const ID_SISTEMA = "695";
export const VERSION_SISTEMA = "11.7";
export const ACCESS_TOKEN_CI = "accessTokenCi";
export const DETALLE_PROCESO_CI = "listaDetalle";
export const ID_CUESTIONARIOS = "correo";
//Formato de fecha
export const formatDate = "DD/MM/YYYY";
export const placeholderDate = "dd/mm/aaaa";
//Constantes de fechas
//export const FECHA_CIERRE_REGISTRO ="07 de mayo de 2023";
export const FECHA_JORNADA_ELECTORAL ="2 de junio de 2024";
//Tipos de documentos
export const ID_DOC_CRED_FRENTE = 1;
export const ID_DOC_CRED_VUELTA = 2;
export const ID_DOC_FOTOGRAFIA = 3;
export const ID_DOC_COMPROBANTE = 4;
export const ID_DOC_ACREDITACION = 5;
export const ID_DOC_CONSTANCIA = 6;
export const ID_DOC_INFORME = 8;
export const ID_DOC_CONSTANCIA_PRE = 9;
export const ID_DOC_GAFETE = 21;
export const ID_DOC_ACREDITACION_OBS = 22;
// Estatus tabla C_ESTATUS
export const ESTATUS_SIN_REVISION = 1;
export const ESTATUS_OBSERVACIONES_ATENDIDAS = 2;
export const ESTATUS_CON_OBSERVACIONES = 3;
export const ESTATUS_VALIDADO = 4;
export const ESTATUS_ELIMINADO = 5;
// Estatus para las pantallas del portal Público
export const PAGE_SIN_REVISION = 1;
export const PAGE_OBSERVACIONES_ATENDIDAS = 2;
export const PAGE_CON_OBSERVACIONES = 3;
export const PRESENCIAL_SIN_ASIGNAR = 4;
export const PRESENCIAL_SIN_ASISTENCIA = 5;
export const CURSO_FINALIZADO = 6;
export const CURSO_LINEA_PENDIENTE = 7;
export const PAGE_ACREDITADO = 8;
export const CURSO_LINEA_TERMINADO = 9;
export const PAGE_INFORMES = 10;
// Tipos de Observaciones tabla C_OBSERVACIONES
export const OBS_CRED_FRENTE = 1;
export const OBS_CRED_VUELTA = 2;
export const OBS_FOTOGRAFIA = 3;
export const OBS_DIF_PERSONA = 4;
export const OBS_NOMBRE = 5;
export const OBS_CLAVE_ELEC = 6;
export const OBS_DIRECCION = 7;
export const OBS_CRED_VIG = 8;
// Tipos de observaciones de la organización tabla C_OBSERVACIONES
export const OBS_SOLICITA_DOC = 9;
export const OBS_VALIDA_DOC = 10;
export const OBS_VALIDA_DATOS_ORG = 11;
export const OBS_VALIDA_REPRE_ORG = 12;
export const OBS_VALIDA_DOM_ORG = 13;
export const OBS_VALIDA_CONT_ORG = 14;
//Sede para el servicio de juntas
export const TIPO_SEDE = 1;
// Origen de la solicitud
export const ORIGEN_PORTAL_PUBLICO = 3;
export const ORIGEN_JUNTA = 4;
export const ORIGEN_OPL = 2;
// TIPO DE OBSERVADOR
export const OBSERVADOR_NACIONAL = 0;
export const OBSERVADOR_EXTRANJERO = 1;
//Usuario CAU
export const USUARIO_CAU = "OBSERVADORES11.CAU.OC";
// Estatus Curso
export const ESTATUS_CURSO_INSCRITO = 4;
//Mensajes para bloquear la pantalla
export const MSN_LOGIN = "Cargando...";
export const MSN_GUARDAR = "Procesando...";
// Puesto del Funcionario
export const FUNCIONARIO_CONSEJERO = 1;
//Cursos en línea
export const MODALIDAD_LINEA = 1;
export const ACT_FINAL = 10;
export const LIMITE_LECCIONES = 8; //es el numero máximo de leciones que tiene el curso
export const CAL_MIN = 7;
export const CAL_MIN_LECCIONES = 7;
export const ACT_VALORACION = 11;
export const MAT_CONSULTA = 12;
export const MSG_GUIA = "Guía Temática para Capacitar a las y los Observadores Electorales";
// ID PUESTO
export const ID_PUESTO_PRESIDENTE = 1;
export const ID_PUESTO_SECRETARIO = 2;
export const ID_PUESTO_ORG_ELECTORAL = 3;
//idModulos del sistema
export const MOD_CONVOCATORIA = 1;
export const MOD_ACCIONES = 2;
export const MOD_REGISTRO_CIU = 3;
export const MOD_REGISTRO_ORG = 4;
export const MOD_VALIDA_SOL = 5;
export const MOD_CONFIG_CRUCES = 6;
export const MOD_REGISTRO_CUR = 7;
export const MOD_REGISTRO_ASIST = 8;
export const MOD_ACREDITACION = 9;
export const MOD_DOCUMENTOS_ACRE = 10;
export const MOD_ESTADO_SOL = 11;
export const MOD_INFORMES = 12;
export const MOD_OBSERVACIONES_OPL = 15;
export const MOD_VALIDA_ORG = 16;
// Nombre proceso
export const NOMBRE_PROCESO = "Proceso Electoral Extraordinario 2024";
//Parametros de Configuraciones
export const IDCORTE = "IDCORTE";
// Estatus para los mensajes del home de la organización 
export const MSJ_ALTA_ORG = 0;
export const MSJ_REV_ORG = 1;
export const MSJ_REV_ORG_CON_OBS = 2;
export const MSJ_REV_ORG_ATENDIDAS = 3;
export const MSJ_ORG_VALIDADA = 4;
export const MSJ_ORG_INACTIVA = 5;